import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, Plus, Mail, Phone, Building2, MoreVertical, CheckCircle2, X, MapPin, ChevronRight } from 'lucide-react';
import { MobileLayout } from '../../components/MobileLayout';
import { useScreenInit } from '../../useScreenInit.js';
import { REFERENTI, TYPE_STYLE } from './referentiData';
export function CmReferentiPage() {
  useScreenInit();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [isAddOpen, setIsAddOpen] = useState(false);
  const filtered = REFERENTI.filter(r => {
    const full = `${r.firstName} ${r.lastName}`.toLowerCase();
    const q = query.toLowerCase();
    return full.includes(q) || r.email.toLowerCase().includes(q) || r.zone.toLowerCase().includes(q);
  });
  return <MobileLayout data-id="element-2948">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6" data-id="element-2949">
        <div data-id="element-2950">
          <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2951">Referenti</h1>
        </div>
        <button onClick={() => setIsAddOpen(true)} className="w-full sm:w-auto px-4 py-2.5 bg-coral text-white rounded-xl hover:bg-coral-600 transition-colors text-sm font-medium min-h-[44px] flex items-center justify-center gap-2" data-id="element-2952">
          <Plus size={18} data-id="element-2953" />
          Aggiungi referente
        </button>
      </div>

      {/* Sub-nav between Referenti / Appartamenti */}
      <div className="inline-flex items-center gap-1 bg-gray-100 rounded-lg p-1 mb-6" data-id="element-2954">
        <span className="px-3 py-1.5 rounded-md text-sm font-medium bg-white text-navy shadow-sm" data-id="element-2955">
          Referenti
        </span>
        <Link to="/cm/clienti/appartamenti" className="px-3 py-1.5 rounded-md text-sm font-medium text-gray-500 hover:text-navy transition-colors" data-id="element-2956">
          Appartamenti
        </Link>
      </div>

      {/* Search */}
      <div className="bg-white p-4 rounded-xl border border-border shadow-sm mb-6" data-id="element-2957">
        <div className="relative" data-id="element-2958">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-2959" />
          <input type="text" placeholder="Cerca per nome, email o zona..." value={query} onChange={e => setQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none transition-all min-h-[44px]" data-id="element-2960" />
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl border border-border shadow-sm overflow-hidden" data-id="element-2961">
        <div className="overflow-x-auto" data-id="element-2962">
          <table className="w-full text-left border-collapse min-w-[760px]" data-id="element-2963">
            <thead data-id="element-2964">
              <tr className="bg-gray-50 border-b border-border" data-id="element-2965">
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2966">
                  Referente
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2967">
                  Tipologia
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2968">
                  Contatti
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2969">
                  Appartamenti
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2970">
                  Contratto
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right" data-id="element-2971">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-2972">
              {filtered.map(r => <tr key={r.id} onClick={() => navigate(`/cm/clienti/referenti/${r.id}`)} className="hover:bg-gray-50/50 transition-colors cursor-pointer" data-id="element-2973">
                  <td className="px-4 lg:px-6 py-4" data-id="element-2974">
                    <div className="flex items-center gap-3" data-id="element-2975">
                      <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-navy font-bold flex-shrink-0 text-sm" data-id="element-2976">
                        {r.firstName[0]}
                        {r.lastName[0]}
                      </div>
                      <div className="min-w-0" data-id="element-2977">
                        <div className="text-sm font-semibold text-navy whitespace-nowrap" data-id="element-2978">
                          {r.firstName} {r.lastName}
                        </div>
                        <div className="flex items-center gap-1 text-xs text-gray-500 whitespace-nowrap" data-id="element-2979">
                          <MapPin size={11} className="text-gray-400" data-id="element-2980" />
                          {r.zone}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2981">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border whitespace-nowrap ${TYPE_STYLE[r.type]}`} data-id="element-2982">
                      {r.type}
                    </span>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2983">
                    <div className="space-y-1" data-id="element-2984">
                      <div className="flex items-center gap-2 text-sm text-gray-600 whitespace-nowrap" data-id="element-2985">
                        <Mail size={14} className="text-gray-400" data-id="element-2986" />
                        {r.email}
                      </div>
                      <div className="flex items-center gap-2 text-sm text-gray-600 whitespace-nowrap" data-id="element-2987">
                        <Phone size={14} className="text-gray-400" data-id="element-2988" />
                        {r.phone}
                      </div>
                    </div>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2989">
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-navy whitespace-nowrap" data-id="element-2990">
                      <Building2 size={14} className="text-gray-400" data-id="element-2991" />
                      {r.apartments}
                    </span>
                  </td>
                  <td className="px-4 lg:px-6 py-4" data-id="element-2992">
                    {r.activeContract ? <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-200 whitespace-nowrap" data-id="element-2993">
                        <CheckCircle2 size={13} data-id="element-2994" />
                        Attivo
                      </span> : <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500 border border-gray-200 whitespace-nowrap" data-id="element-2995">
                        Nessuno
                      </span>}
                  </td>
                  <td className="px-4 lg:px-6 py-4 text-right" data-id="element-2996">
                    <div className="flex items-center justify-end gap-1" data-id="element-2997">
                      <button onClick={e => e.stopPropagation()} aria-label="Azioni referente" className="p-2 text-gray-400 hover:text-navy rounded-lg hover:bg-gray-100 transition-colors" data-id="element-2998">
                        <MoreVertical size={18} data-id="element-2999" />
                      </button>
                      <ChevronRight size={18} className="text-gray-300 flex-shrink-0" data-id="element-3000" />
                    </div>
                  </td>
                </tr>)}
              {filtered.length === 0 && <tr data-id="element-3001">
                  <td colSpan={6} className="px-6 py-10 text-center text-sm text-gray-500" data-id="element-3002">
                    Nessun referente trovato.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Referente Modal */}
      {isAddOpen && <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setIsAddOpen(false)} data-id="element-3003">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Nuovo referente" data-id="element-3004">
            <div className="flex items-center justify-between p-4 border-b border-border" data-id="element-3005">
              <h2 className="text-lg font-bold text-navy" data-id="element-3006">Nuovo referente</h2>
              <button onClick={() => setIsAddOpen(false)} aria-label="Chiudi" className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-3007">
                <X size={20} className="text-gray-500" data-id="element-3008" />
              </button>
            </div>
            <div className="p-4 overflow-y-auto space-y-4" data-id="element-3009">
              <div className="grid grid-cols-2 gap-4" data-id="element-3010">
                <div data-id="element-3011">
                  <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-3012">
                    Nome
                  </label>
                  <input type="text" placeholder="Mario" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-3013" />
                </div>
                <div data-id="element-3014">
                  <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-3015">
                    Cognome
                  </label>
                  <input type="text" placeholder="Rossi" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-3016" />
                </div>
              </div>
              <div data-id="element-3017">
                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-3018">
                  Tipologia
                </label>
                <select className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none bg-white min-h-[44px]" data-id="element-3019">
                  <option data-id="element-3020">Host</option>
                  <option data-id="element-3021">Property Manager</option>
                  <option data-id="element-3022">B&B</option>
                  <option data-id="element-3023">Agenzia</option>
                </select>
              </div>
              <div data-id="element-3024">
                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-3025">
                  Email
                </label>
                <input type="email" placeholder="mario.rossi@example.com" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-3026" />
              </div>
              <div data-id="element-3027">
                <label className="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5" data-id="element-3028">
                  Telefono
                </label>
                <input type="tel" placeholder="+39 333 1234567" className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none min-h-[44px]" data-id="element-3029" />
              </div>
            </div>
            <div className="p-4 border-t border-border bg-gray-50 flex justify-end gap-3" data-id="element-3030">
              <button onClick={() => setIsAddOpen(false)} className="px-4 py-2.5 bg-white border border-border text-gray-700 rounded-full hover:bg-gray-50 transition-colors text-sm font-medium min-h-[44px]" data-id="element-3031">
                Annulla
              </button>
              <button onClick={() => setIsAddOpen(false)} className="px-6 py-2.5 bg-coral text-white rounded-xl hover:bg-coral-600 transition-colors text-sm font-medium min-h-[44px]" data-id="element-3032">
                Salva referente
              </button>
            </div>
          </div>
        </div>}
    </MobileLayout>;
}